import { render, staticRenderFns } from "./user_questions.vue?vue&type=template&id=4b33bfb4&scoped=true"
import script from "./user_questions.vue?vue&type=script&lang=js"
export * from "./user_questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33bfb4",
  null
  
)

export default component.exports